import { once } from 'es-toolkit/compat'

export default once
